export default "__VITE_ASSET__Y7OUQ5aD__"